<div class="modal-wrapper" draggable dragHandle=".drag-header" dragTarget=".modal-content" [disableDrag]="disableMove"
     [dragTargetDirection]="searchDirection.Up">
    @if (loading) {
        <ws-ace-loader></ws-ace-loader>
    }
    <div class="modal-header" [ngClass]="{'ace-modal-header': useAceStyles, 'drag-header': !useAceStyles}">
        @if (useAceStyles && !hideCancelX) {
            <div class="ace-modal-close-container">
                <div class="drag-header"></div>
                <div class="ace-modal-close" (click)="cancelClicked()">
                    <span class="ace-modal-close-text">Close</span>
                    <img class="ace-modal-close-icon" src="/images/Union.svg" alt="">
                </div>
            </div>
        }
        <div class="header-contents ws-flex-container-horizontal ws-flex-align-items-center ws-stretch-width"
             [ngClass]="{'ace-modal-header-contents': useAceStyles}">
            <div class="ws-flex-container-vertical" [ngClass]="{'ace-modal-title-container': useAceStyles}">
                <div class="ws-flex-container-horizontal ws-flex-align-items-center">
                    @if (headerIcon) {
                        <i
                            class="header-icon fa"
                            [ngClass]="headerIcon"
                            helpTooltip
                            [helpContentId]="headerIconHelpContentId"
                            [helpDisabled]="!headerIconHelpContentId">
                        </i>
                    }
                    @if (headerLabel) {
                        <h4
                            helpTooltip
                            [helpContentId]="headerHelpContentId"
                            [helpDisabled]="!headerHelpContentId"
                            class="modal-title float-start"
                            [ngClass]="{ 'clickable ace-btn btn-link': isHeaderLink, 'ace-modal-title': useAceStyles }"
                            (click)="headerClicked()">
                            {{ headerLabel }}
                        </h4>
                    }
                </div>
                @if (subHeaderLabel) {
                    <span class="modal-header-subtext ws-text-align-left">{{ subHeaderLabel }}</span>
                }
            </div>
            @if (!useAceStyles) {
                <span class="float-end">
                    @if (!hideCancelX) {
                        <button
                            type="button"
                            class="btn-close"
                            aria-label="Close"
                            [disabled]="loading"
                            (click)="cancelClicked()"></button>
                    }
                </span>
            }
        </div>
    </div>
    <div class="modal-body modal-wrapper-body exclude-modal-styling"
         [ngClass]="bodyClass"
         [class.exclude-modal-styling-border]="excludeModalStyling"
         [class.ace-modal-body]="useAceStyles"
         [class.modal-loading]="loading">
        <ng-content></ng-content>
    </div>
    @if (hasCustomFooter) {
        <div class="modal-footer">
            <ng-content select="[modal-footer]"></ng-content>
        </div>
    }
    @if (!hideFooter && !hasCustomFooter) {
        <div class="modal-footer">
            <div class="ws-flex-container-horizontal ws-stretch-width"
                 [ngClass]="{ 'ws-flex-justify-content-space-between': footerLabel || auxButtonLabel, 'ws-flex-justify-content-flex-end': !footerLabel, 'ws-flex-justify-content-center': !footerLabel && useAceStyles }">
                @if (auxButtonLabel) {
                    <div>
                        <div helpTooltip [helpContentId]="auxButtonHelpContentId">
                            @if (!hideAuxButton) {
                                <button type="button"
                                        class="ace-btn"
                                        [ngClass]="auxButtonClass"
                                        [disabled]="disableAuxButton"
                                        (click)="auxButton.emit()"
                                        [attr.tabindex]="(disableSave ? tabindex + 1 : tabindex + 2)">
                                    {{ auxButtonLabel }}
                                </button>
                            }
                        </div>
                    </div>
                }
                @if (footerLabel) {
                    <div>
                        <span class="description" [attr.title]="footerLabel">
                            {{ footerLabel }}
                        </span>
                    </div>
                }
                @if (!useAceStyles) {
                    <div class="ws-flex-container-horizontal ws-flex-align-items-center">
                        <div helpTooltip [helpContentId]="acceptHelpContentId">
                            @if (!hideSave) {
                                <button type="button"
                                        class="ace-btn has-text"
                                        [ngClass]="acceptClass"
                                        [disabled]="disableSave || loading"
                                        (click)="save.emit()"
                                        [attr.tabindex]="(!disableSave && tabindex)">
                                    {{ acceptLabel }}
                                </button>
                            }
                        </div>
                        <div helpTooltip [helpContentId]="cancelHelpContentId">
                            @if (!hideCancel) {
                                <button type="button"
                                        class="ace-btn"
                                        [ngClass]="cancelClass"
                                        [disabled]="disableCancel || loading"
                                        (click)="cancelClicked()"
                                        [attr.tabindex]="(disableSave ? tabindex : tabindex + 1)">
                                    {{ cancelLabel }}
                                </button>
                            }
                        </div>
                    </div>
                }
                @if (useAceStyles) {
                    <div class="d-flex button-con flex-row-reverse justify-content-center">
                        @if (!hideSave) {
                            <ws-ace-button
                                class="mx-2"
                                state="action"
                                buttonStyle="primary"
                                [content]="acceptLabel"
                                [isDisabled]="disableSave || loading"
                                (buttonClick)="save.emit()"
                                [attr.tabindex]="(!disableCancel ? tabindex : tabindex + 1)"
                                helpTooltip
                                [helpContentId]="acceptHelpContentId">
                            </ws-ace-button>
                        }
                        @if (!hideCancel) {
                            <ws-ace-button
                                class="mx-2"
                                state="action"
                                buttonStyle="secondary"
                                [content]="cancelLabel"
                                [isDisabled]="disableCancel || loading"
                                (buttonClick)="cancelClicked()"
                                [attr.tabindex]="(!disableCancel && tabindex)"
                                helpTooltip
                                [helpContentId]="cancelHelpContentId">
                            </ws-ace-button>
                        }
                    </div>
                }
            </div>
        </div>
    }
</div>
